import { createTheme, Theme } from '@mui/material'

export function getAppTheme (): Theme {
  const theme = {
    palette: {
      primary: {
        main: '#e16969',
      },
      secondary: {
        main: '#ef867f',
      },
    },
    typography: {
      fontFamily: "Winky Sans",
      h1: {
        textTransform: 'uppercase',
        fontSize: 50,
        //textDecoration: 'underline',
        color: '#373e59',
        margin: '16px 0px',
      },
      h2: {
        fontSize: 22,
        color: '#373e59',
        margin: '16px 0',
      },
      h3: {
        fontWeight: 'bold',
        fontSize: 16,
        margin: '10px 0',
      },
    },
  }

  return createTheme(theme as Theme)
}
